import { Controller } from "@hotwired/stimulus";

/**
 * Счётчик символов у текстового поля.
 *
 * Предел берётся из maxlength самого поля: два источника правды тут не нужны.
 */
export default class extends Controller {
  static targets = ["input", "output"];

  connect() {
    this.update();
  }

  /** Перерисовывает счётчик и подсвечивает достижение предела. */
  update() {
    const max = Number(this.inputTarget.getAttribute("maxlength")) || 0;
    const length = this.inputTarget.value.length;

    this.outputTarget.textContent = `${length}/${max}`;
    this.outputTarget.classList.toggle("u-text-danger", max > 0 && length >= max);
  }
}
